import QuestionRenderer from './QuestionRenderer';
import { SchemaStep } from './encodeDecodeAnswers';
import ReasonCallout from './steps/ReasonCallout';
import { CONDITION_GOOD_VALUES } from './steps/conditionGoodValues';

const StepQuestions = ({ step }: { step: SchemaStep }) => {
  const active = step.questions.filter((q) => q.active);
  return (
    <>
      {step.stepId === 'condition_check' && <ReasonCallout />}
      {active
        .filter((q) => q.showWhen == null)
        .map((q) => (
          <QuestionRenderer
            key={q.questionId}
            question={q}
            goodValue={CONDITION_GOOD_VALUES[q.questionId]}
            dependents={active.filter((d) => d.showWhen?.questionId === q.questionId)}
          />
        ))}
    </>
  );
};

export default StepQuestions;
